import React from 'react';
import PropTypes from 'prop-types';

class LogOutBooth extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    this.props.logout();
    this.props.router.replace('/make-some-noiz');
  }

  render() {
    return (
      <h1>Logged Out.</h1>
    );
  }
}

LogOutBooth.propTypes = {
  router: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  logout: PropTypes.func.isRequired,
};

export default LogOutBooth;
